var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{},[(_vm.user.avatar_url)?[_c('img',{staticClass:"rounded-circle img-fluid avatar",attrs:{"src":_vm.user.avatar_url,"alt":""}})]:[_c('i',{staticClass:"bi bi-person-circle avatar-default"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }